import Vue from 'vue'
import { Button } from 'vant'
import { Area } from 'vant'
import { Popup } from 'vant'
import { Field } from 'vant'
import { Cell, CellGroup } from 'vant'
import { DatetimePicker } from 'vant'
import { RadioGroup, Radio } from 'vant'
import { Icon } from 'vant'
import { Picker } from 'vant'
import { Checkbox, CheckboxGroup } from 'vant'
import { Cascader, NavBar, IndexBar, IndexAnchor, } from 'vant'

Vue.use(Icon)
Vue.use(Button)
Vue.use(Area)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Cell).use(CellGroup)
Vue.use(DatetimePicker)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Area)
Vue.use(Picker)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Cascader)
Vue.use(NavBar)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
